import type { AxiosRequestConfig } from 'axios';

import type {
  PageSettingsSchema,
  SettingResponse,
  SettingsRequest,
} from '../model/types';
import { authInstance } from '@/shared/api/api-instances/auth/api-instance';

export class AuthSettingsApi {
  static getAllSettings(params = {}, options: AxiosRequestConfig = {}) {
    return authInstance.get<PageSettingsSchema>(`/settings`, {
      ...options,
      params,
    });
  }

  static getSettingById(setting_id: string, options: AxiosRequestConfig = {}) {
    return authInstance.get<SettingResponse>(
      `/settings/${setting_id}`,
      options,
    );
  }

  static editSetting(
    setting_id: string,
    payload: SettingsRequest,
    options: AxiosRequestConfig = {},
  ) {
    return authInstance.put<SettingResponse>(
      `/settings/${setting_id}`,
      payload,
      options,
    );
  }
}